import React from 'react';

import { Loader } from '../.';
import { useAppSelector } from 'redux/hooks';
import {withParamsFrame} from "../../HOCs";
import {IframePage} from "../../types/iframe";

const Products: React.FC<IframePage> = ({ params }) => {

    const { sellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id,
    }))

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={'page-iframe'} src={`https://lk.market/${sellerId}/pim/active${params}`}
                    title="Products"
                    width="100%"
                    height={"calc(100vh-64px)"}

                ></iframe>
            </div>
        </>
    );

}
export default withParamsFrame(Products);
